<template>
  <v-dialog
    overlay-color="black"
    overlay-opacity="0.7"
    persistent
    max-width="350"
    v-model="show"
  >
    <v-card>
      <v-card-title class="headline">{{ title }}</v-card-title>
      <v-card-text>{{ text }}</v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          v-if="action"
          :color="action.color || 'primary'"
          text
          @click="action.onClick"
        >
          {{ action.title }}
        </v-btn>
        <v-btn text @click="dismiss">Dismiss</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    show: { type: Boolean, required: true },
    title: { type: String, required: true },
    text: { type: String, required: true },
    action: { type: Object, default: null }
  },
  methods: {
    dismiss() {
      this.$emit("update:show", false);
    }
  }
};
</script>
